import { useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import {
  CredentialCard,
  CredentialCardType,
  CredentialMini,
} from '../../components/credential/credential.component';
import { CredentialType } from '../../common/mapper/credential.mapper';
import { useStoreUIV1 } from '@gimlite/ui-v1';

export class SKIDATACredentialStatic {
  static info: CredentialType.Static<SKIDATACredentialCardType.Data> = {
    name: 'SKIDATA',
    icon: 'partnerSKIDATA',
    backgroundColor: { light: '#63686e', dark: '#63686e' },
    color: { light: '#e8e8e8', dark: '#e8e8e8' },
    category: 'RFID',
    primaryValue: 'externalId',
  };
}

export declare namespace SKIDATACredentialMiniType {
  type Props = {
    data?: {
      value?: string | null;
    };
  };
}

export const SKIDATACredentialMini = observer(
  ({ data: { value } = {} }: SKIDATACredentialMiniType.Props) => {
    const { ThemeStore } = useStoreUIV1();

    return (
      <CredentialMini
        data={{ text: value }}
        config={{
          icon: SKIDATACredentialStatic.info.icon,
          backgroundColor:
            SKIDATACredentialStatic.info.backgroundColor[ThemeStore.theme],
          color: SKIDATACredentialStatic.info.color[ThemeStore.theme],
        }}
      />
    );
  },
);

export declare namespace SKIDATACredentialCardType {
  type Props = {
    handleEvent?: {
      event?: CredentialCardType.HandleEvent.Event['function'];
    };
    data: SKIDATACredentialCardType.Data;
    config?: {
      isActive?: boolean;
    };
  };

  type Data = {
    _id: string;
    externalId: string;
  };
}

export const SKIDATACredentialCard = observer(
  ({
    handleEvent: { event } = {},
    data: { _id, externalId },
    config: { isActive = true } = {},
  }: SKIDATACredentialCardType.Props) => {
    const { t, lang } = useTranslation();
    const { ThemeStore } = useStoreUIV1();

    return (
      <CredentialCard.Context.Consumer>
        {({ place, edit }) => (
          <CredentialCard
            handleEvent={{ event, edit }}
            data={{
              name: SKIDATACredentialStatic.info.name,
              info: [
                {
                  key: 'externalId',
                  label: t('externalId'),
                  value: externalId,
                  _id,
                },
              ],
              category: SKIDATACredentialStatic.info.category,
              primaryValue: SKIDATACredentialStatic.info.primaryValue,
            }}
            config={{
              icon: SKIDATACredentialStatic.info.icon,
              backgroundColor:
                SKIDATACredentialStatic.info.backgroundColor[ThemeStore.theme],
              color: SKIDATACredentialStatic.info.color[ThemeStore.theme],
              disabled: !isActive,
              action:
                place === 'contractDisabled'
                  ? []
                  : !isActive
                    ? [{ label: t('import'), value: 'import' }]
                    : place === 'wizardContractExist'
                      ? [{ label: t('delete'), value: 'delete' }]
                      : place === 'wizardNewContract'
                        ? [{ label: t('delete'), value: 'delete' }]
                        : place === 'contract'
                          ? [{ label: t('delete'), value: 'delete' }]
                          : [],
            }}
          />
        )}
      </CredentialCard.Context.Consumer>
    );
  },
);
